module.exports = __webpack_public_path__ + "static/media/quienesSomos.3d57645a.png";